import { axios } from 'src/lib/axios';
import { errorHandler } from 'src/utils/Error';
import { API_URL } from 'src/config';


export const getVehicles = (params) => {
  return axios(`${API_URL}/admin/vehicles`, { params }).catch((error) =>
    errorHandler(error),
  );
};

export const getVehicle = (id) => {
  return axios(`${API_URL}/admin/vehicles/${id}`).catch((error) => errorHandler(error));
};

export const createVehicle = (data) => {
  return axios.post(`${API_URL}/admin/vehicles`, data);
};

export const updateVehicle = ({ id, data }) => {
  return axios.put(`${API_URL}/admin/vehicles/${id}`, data);
};

export const deleteVehicle = (id) => {
  return axios.delete(`${API_URL}/admin/vehicles/${id}`);
};

export const getAllVehicles = () => {
  return axios(`${API_URL}/admin/vehicles_all`).catch((error) => errorHandler(error));
};

export const getReports = (params) => {
  return axios(`${API_URL}/admin/vehicle-reports`, { params }).catch((error) => errorHandler(error));
};
